import withdrawalActionTypes from './withdrawals.types';

export const fetchWithdrawalsStart = (token) => ({
    type: withdrawalActionTypes.FETCH_WITHDRAWALS_START,
    payload: token
});

export const fetchWithdrawalsSuccess = (withdrawals) => ({
    type: withdrawalActionTypes.FETCH_WITHDRAWALS_SUCCESS,
    payload: withdrawals
});

export const fetchWithdrawalsFailure = (error) => ({
    type: withdrawalActionTypes.FETCH_WITHDRAWALS_FAILURE,
    payload: error
});

export const createWithdrawalStart = ({ token, amount, bankName, accountNumber, accountName }) => ({
    type: withdrawalActionTypes.CREATE_WITHDRAWAL_START,
    payload: { token, amount, bankName, accountNumber, accountName }
});

export const createWithdrawalSuccess = (withdrawal) => ({
    type: withdrawalActionTypes.CREATE_WITHDRAWAL_SUCCESS,
    payload: withdrawal
});

export const createWithdrawalFailure = (error) => ({
    type: withdrawalActionTypes.CREATE_WITHDRAWAL_FAILURE,
    payload: error
});
